/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement, noShadowDOM } from 'solid-element';
import CustomTooltip, { CustomTooltipProps } from './CustomTooltip';
import { attachChildren } from '../util';

declare module 'solid-js' {
  namespace JSX {
    interface IntrinsicElements {
      'tc-custom-tooltip': Partial<HTMLElement> &
        CustomTooltipProps &
        Partial<{ ref: (el: HTMLElement | null) => void }>;
    }
  }
}

export function defineSolidCustomTooltip(): void {
  customElement(
    'tc-custom-tooltip',
    {
      text: undefined,
      position: undefined,
      notDynamic: false,
      disableToolTip: false,
      className: undefined,
      arrow: false,
      children: undefined,
      tooltipClass: undefined,
      class: undefined,
    },
    (props, { element }) => {
      noShadowDOM();

      return (
        <CustomTooltip
          text={props.text}
          position={props.position}
          notDynamic={props.notDynamic}
          disableToolTip={props.disableToolTip}
          // eslint-disable-next-line sonarjs/deprecation -- deprecated prop kept for backwards compatibility
          className={props.className}
          arrow={props.arrow}
          tooltipClass={props.tooltipClass}
          class={props.class}
          containerRef={(wrapper) => {
            attachChildren(element as unknown as HTMLElement, wrapper);
          }}
        />
      );
    }
  );
}
